import { FormSubmissionCommentAttachmentService as OvermapFormSubmissionCommentAttachmentService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class FormSubmissionCommentAttachmentService extends OvermapFormSubmissionCommentAttachmentService<
	RootState,
	AppSDK
> {
	host = import.meta.env.REACT_APP_API_URL
}
